
import BlogHtmlFile from '~/components/Common/Blog/BlogHtmlFile'

export default {
    name: 'MiddleFeatures',
    components: { BlogHtmlFile },
}
